module.exports = __webpack_public_path__ + "img/Eddie Nketiah.020a0161.png";